import React from "react";
import { Link } from "react-router";

type Props = {
  children: React.ReactNode;
  path: string;
};

const MenuLink = React.forwardRef<HTMLAnchorElement, Props>(
  ({ children, path }, ref) => {
    return (
      <Link ref={ref} className={"block text-center italic link"} to={path}>
        {children}
      </Link>
    );
  }
);

MenuLink.displayName = "MenuLink";
export default MenuLink;
